import { useState } from "react";
import {
    Search,
    RotateCcw,
    RefreshCw,
    Download,
    Plus,
    CalendarDays,
} from "lucide-react";

export default function FilterToolbar({
    warehouses = [],
    racks = [],
    onSearch,
    onReset,
    onRefresh,
    onExport,
    onCreate,
}) {
    const [filter, setFilter] = useState({
        keyword: "",
        warehouse_id: "",
        rack_code: "",
        status: "",
        date_from: "",
        date_to: "",
    });

    const handleChange = (e) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value,
        });
    };

    return (
        <div className="bg-white border border-slate-200 rounded-xl shadow-sm mb-6">

            {/* Header */}
            <div className="border-b px-6 py-4 flex items-center justify-between">

                <div>
                    <h1 className="text-3xl font-bold text-slate-800">
                        Beginning Balance
                    </h1>

                    <p className="text-gray-500 mt-1">
                        Manage warehouse opening stock
                    </p>

                </div>

                <button
                    onClick={onRefresh}
                    className="flex items-center gap-2 border px-4 py-2 rounded-lg hover:bg-gray-50"
                >
                    <RefreshCw size={18} />

                    Refresh
                </button>

            </div>

            {/* Filter */}
            <div className="p-6">

                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-6 gap-4">

                    {/* Search */}
                    <div className="xl:col-span-2">

                        <label className="text-sm text-gray-500">
                            Search
                        </label>

                        <input
                            type="text"
                            name="keyword"
                            value={filter.keyword}
                            onChange={handleChange}
                            placeholder="Batch Number..."
                            className="w-full mt-1 border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
                        />

                    </div>

                    {/* Warehouse */}
                    <div>

                        <label className="text-sm text-gray-500">
                            Warehouse
                        </label>

                        <select
                            name="warehouse_id"
                            value={filter.warehouse_id}
                            onChange={handleChange}
                            className="w-full mt-1 border rounded-lg px-3 py-2"
                        >
                            <option value="">
                                All Warehouse
                            </option>

                            {warehouses.map((item) => (
                                <option
                                    key={item.id}
                                    value={item.id}
                                >
                                    {item.name}
                                </option>
                            ))}

                        </select>

                    </div>

                    {/* Rack */}
                    <div>

                        <label className="text-sm text-gray-500">
                            Rack
                        </label>

                        <select
                            name="rack_code"
                            value={filter.rack_code}
                            onChange={handleChange}
                            className="w-full mt-1 border rounded-lg px-3 py-2"
                        >
                            <option value="">
                                All Rack
                            </option>

                            {racks.map((item) => (
                                <option
                                    key={item.code}
                                    value={item.code}
                                >
                                    {item.code}
                                </option>
                            ))}

                        </select>

                    </div>

                    {/* Status */}
                    <div>

                        <label className="text-sm text-gray-500">
                            Status
                        </label>

                        <select
                            name="status"
                            value={filter.status}
                            onChange={handleChange}
                            className="w-full mt-1 border rounded-lg px-3 py-2"
                        >
                            <option value="">
                                All Status
                            </option>

                            <option value="Draft">
                                Draft
                            </option>

                            <option value="Posted">
                                Posted
                            </option>

                            <option value="Cancelled">
                                Cancelled
                            </option>

                        </select>

                    </div>

                    {/* Date */}
                    <div>

                        <label className="text-sm text-gray-500">
                            Date
                        </label>

                        <div className="relative">

                            <CalendarDays
                                size={18}
                                className="absolute left-3 top-3 text-gray-400"
                            />

                            <input
                                type="date"
                                name="date_from"
                                value={filter.date_from}
                                onChange={handleChange}
                                className="w-full border rounded-lg pl-10 pr-3 py-2"
                            />

                        </div>

                    </div>

                </div>

                {/* Action */}
                <div className="flex flex-wrap gap-3 mt-6">

                    <button
                        onClick={() => onSearch?.(filter)}
                        className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-lg flex items-center gap-2"
                    >
                        <Search size={18} />

                        Search
                    </button>

                    <button
                        onClick={() => {
                            setFilter({
                                keyword: "",
                                warehouse_id: "",
                                rack_code: "",
                                status: "",
                                date_from: "",
                                date_to: "",
                            });

                            onReset?.();
                        }}
                        className="border px-5 py-2 rounded-lg hover:bg-gray-100 flex items-center gap-2"
                    >
                        <RotateCcw size={18} />

                        Reset
                    </button>

                    <button
                        onClick={onExport}
                        className="bg-emerald-600 hover:bg-emerald-700 text-white px-5 py-2 rounded-lg flex items-center gap-2"
                    >
                        <Download size={18} />

                        Export Excel
                    </button>

                    <button
                        onClick={onCreate}
                        className="ml-auto bg-blue-700 hover:bg-blue-800 text-white px-5 py-2 rounded-lg flex items-center gap-2"
                    >
                        <Plus size={18} />

                        New Beginning
                    </button>

                </div>

            </div>

        </div>
    );
}